import HttpClient from '@services/utils/HttpClient';

import { type ICreateSuggestInputData } from './dtos/createSuggest/InputData';
import { type ISuggestRepository } from './ISuggestRepository';

interface ICreateBody {
  area: string;
  descricao: string;
}

class SuggestService implements ISuggestRepository {
  public async create(inputData: ICreateSuggestInputData): Promise<void> {
    await HttpClient.post<unknown, ICreateBody>({
      path: 'sugestao.php',
      body: {
        area: inputData.area,
        descricao: inputData.descricao,
      },
    });
  }
}

export default new SuggestService();
